import _ from 'lodash'
import { PaymentIntent } from '@stripe/stripe-js'
import { CommonState, Model } from '@/core/classes/Model'
import { Consultation } from '@/core/models/consultation.model'

export type ChargeState = CommonState

class ChargeModel extends Model {
  static instance: ChargeModel

  static getInstance() {
    if (!ChargeModel.instance) {
      ChargeModel.instance = new ChargeModel('charge')
    }
    return ChargeModel.instance
  }

  getInitialState(): ChargeState {
    return _.merge({}, this.commonState, {
      requestTracker: {
        acceptPayment: { error: null, loading: false },
        setPrice: { error: null, loading: false }
      }
    })
  }

  startPayment = async (consultationId: string): Promise<PaymentIntent> => {
    return await this.httpClient.request<PaymentIntent>(`/charge/${consultationId}/pay`, 'POST')
  }

  startPaymentByReceiverID = async (consultationId: string, receiverID: string): Promise<PaymentIntent> => {
    return await this.httpClient.request<PaymentIntent>(`/charge/${consultationId}/pay/other`, 'POST', {
      receiverID
    })
  }

  confirmPayment = async (consultationId: string): Promise<Consultation> => {
    return await this.httpClient.request<Consultation>(`/charge/${consultationId}/confirmation`, 'GET')
  }

  openStellair = async (consultationId: string): Promise<string> => {
    return await this.httpClient.request<string>(`/charge/${consultationId}/stellair`, 'GET')
  }

}

export default ChargeModel.getInstance()
